/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useState, useMemo } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import { icons, LABELS, URLS } from "../../../shared/constants";
import { UserType } from "../../../shared/constants/resource";
import authProvider from "../../../shared/config/authProvider";
import { UserImage } from "../../../App/assets/img";
import { useEffect } from "react";
import {
  useNotificationListQuery,
  useNotificationUnreadCountQuery,
  useNotificationMarkReadMutation,
} from "../../../Features/notification/notification-slice";

const Navbar = (props: any) => {
  const { title, backArrow, handleBack } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const { authState } = authContext;

  const [showDropdown, setShowDropdown] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState<{ [key: string]: boolean }>({});



  const match = location.pathname.match(/^\/order-details\/([a-f0-9]+)/i);
  const activeOrderId = match ? match[1] : null;

  const { data: unreadData, refetch: refetchUnread } =
    useNotificationUnreadCountQuery(undefined, {
      pollingInterval: 2000,
    });

  const { data: notifListData, refetch: refetchList } = useNotificationListQuery(
    {},
    {
      pollingInterval: 2000,
      refetchOnMountOrArgChange: true,
    }
  );

  const [markRead] = useNotificationMarkReadMutation();

  useEffect(() => {
    const handleFocus = () => {
      try {
        refetchUnread();
        if (typeof refetchList === "function") {
          refetchList();
        }
      } catch (e) {
        // Safe guard
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [refetchUnread, refetchList]);

  useEffect(() => {
    if (activeOrderId) {
      markRead({ orderId: activeOrderId });
    }
  }, [activeOrderId, unreadData?.unreadCount, markRead]);

  const rawUnreadCount = unreadData?.unreadCount || 0;
  const rawNotificationList = notifListData?.list || [];

  // Filter out notifications for the currently active order chat screen
  const notificationList = useMemo(() => {
    if (!activeOrderId) return rawNotificationList;
    return rawNotificationList.filter((item: any) => {
      const itemOrderId =
        typeof item.order === "object"
          ? item.order?._id?.toString()
          : item.order?.toString();
      return (
        itemOrderId !== activeOrderId && item.documentNo !== activeOrderId
      );
    });
  }, [rawNotificationList, activeOrderId]);

  // Compute unread count excluding the active order chat
  const unreadCount = useMemo(() => {
    if (rawUnreadCount === 0) return 0;
    if (!activeOrderId) return rawUnreadCount;
      if (notifListData?.list && notifListData.list.length > 0) {
      return notifListData.list.filter((item: any) => {
        if (item.isRead) return false;
        const itemOrderId =
          typeof item.order === "object"
            ? item.order?._id?.toString()
            : item.order?.toString();
       return (
          itemOrderId !== activeOrderId && item.documentNo !== activeOrderId
        );
      }).length;
    }
    return 0;
  }, [rawUnreadCount, notifListData, activeOrderId]);

  // Group notifications by Order
  const groupedNotifications = useMemo(() => {
    const groups: {
      [key: string]: {
        orderId: string;
        documentNo: string;
        title: string;
        items: any[];
      };
    } = {};

    notificationList.forEach((item: any) => {
      const itemOrderId =
        typeof item.order === "object"
          ? item.order?._id?.toString()
          : item.order?.toString();
       if (
        activeOrderId &&
        (itemOrderId === activeOrderId || item.documentNo === activeOrderId)
      ) {
        return;
      }

      const key = itemOrderId || item.documentNo || "other";
      if (!groups[key]) {
        groups[key] = {
          orderId: itemOrderId,
          documentNo: item.documentNo || "Order",
          title: `Order #${item.documentNo || "Details"}`,
          items: [],
        };
      }
      groups[key].items.push(item);
    });

    return Object.values(groups);
  }, [notificationList]);

  const toggleGroupExpand = (key: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setExpandedGroups((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const IMAGE_URL = process.env.REACT_APP_BACKEND_URL + "/uploads/";

  let username = authState?.userInfo?.item.name;
  let userLogo = authState?.userInfo?.item.image;

  const userType = authProvider.getUserData()?.item?.type;
  const isBackOffice =
    userType === UserType.BO || userType === UserType.SUPER;

  const handleLogout = async () => {
    await authContext.setAuthState({ userInfo: {} });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("x-access-token");
    localStorage.clear();
    navigate(URLS.LOGIN);
  };

    const handleDropdownToggle = (isOpen: boolean) => {
    if (isOpen && unreadCount === 0) {
      setShowDropdown(false);
      return;
    }
    setShowDropdown(isOpen);
    if (isOpen) {
      try {
        if (typeof refetchList === "function") {
          refetchList();
        }
      } catch (e) {
        // Safe guard
      }
      try {
        if (typeof refetchUnread === "function") {
          refetchUnread();
        }
      } catch (e) {
        // Safe guard
      }
    }
  };

  const handleNotificationClick = async (item: any) => {
    if (!item.isRead) {
      await markRead(item._id);
    }
    setShowDropdown(false);
    const targetOrderId = typeof item.order === "object" ? item.order?._id : item.order;
    if (targetOrderId) {
      navigate(`/order-details/${targetOrderId}#order-chat`, {
        state: { scrollToChat: true },
      });
    } else {
      navigate(URLS.ORDER);
    }
  };

  const handleGroupTitleClick = async (group: any, e: React.MouseEvent) => {
    e.stopPropagation();
    for (const item of group.items) {
      if (!item.isRead) {
        await markRead(item._id);
      }
    }
    setShowDropdown(false);
    if (group.orderId) {
      navigate(`/order-details/${group.orderId}#order-chat`, {
        state: { scrollToChat: true },
      });
      const elem = document.getElementById("order-chat");
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(URLS.ORDER);
    }
  };
  const handleMarkAllRead = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await markRead(undefined);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary top-nav">
      <div className="container-fluid">
        <div className="navbar-collapse">
          <ul className="navbar-nav">
            <li className="nav-item">
              <div className="nav-link page-title ">
                {backArrow && (
                  <i
                    className="icon icon-chevron-left mr-2 font-14 back-arrow cursor-pointer"
                    onClick={handleBack}
                  ></i>
                )}
                {title}
              </div>
            </li>
          </ul>
          <ul className="navbar-nav right-navbar ms-auto align-items-center">
            {isBackOffice && (
              <li className="nav-item">
                <Dropdown
                  show={unreadCount > 0 && showDropdown}
                  onToggle={handleDropdownToggle}
                  align="end"
                >
                  <Dropdown.Toggle
                    as="a"
                     className="nav-link notification-dropdown-toggle caret-hide cursor-pointer"
                    title={LABELS.ORDER_COMMUNICATION_TEXT}
                    id="notification-dropdown-toggle"
                  >
                    <i className={`icon ${icons.ICON_NOTIFICATION}`}></i>
                    {unreadCount > 0 && (
                      <span className="notification-badge">
                        {unreadCount > 99 ? "99+" : unreadCount}
                      </span>
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="notification-dropdown-menu">
                    <div className="notification-dropdown-header">
                      <h6>Notifications</h6>
                      {unreadCount > 0 && (
                        <button
                          type="button"
                          className="notification-mark-all-btn"
                          onClick={handleMarkAllRead}
                        >
                          Mark all as read
                        </button>
                      )}
                    </div>
                    {groupedNotifications.length === 0 ? (
                      <div className="text-center py-3 text-muted font-13">
                        No notifications
                      </div>
                    ) : (
                      groupedNotifications.map((group: any) => {
                        const groupKey = group.orderId || group.documentNo;
                        const isExpanded = !!expandedGroups[groupKey];

                        if (group.items.length === 1) {
                          const item = group.items[0];
                          return (
                            <div
                              key={item._id}
                              className={`notification-item ${!item.isRead ? "unread" : ""
                                }`}
                              onClick={() => handleNotificationClick(item)}
                            >
                              <div className="notification-title-row">
                                <span className="notification-item-title">
                                  {item.title}
                                </span>
                                {!item.isRead && (
                                  <span className="notification-unread-dot" />
                                )}
                              </div>
                              {item.message && (
                                <div className="notification-item-msg">
                                  {item.message}
                                </div>
                              )}
                              <div className="notification-item-time">
                                {moment(item.createdAt).fromNow()}
                              </div>
                            </div>
                          );
                        }

                        return (
                          <div key={groupKey} className="notification-group-card">
                            <div
                              className="notification-group-header cursor-pointer"
                              onClick={(e) => toggleGroupExpand(groupKey, e)}
                            >
                              <div className="notification-group-title-box">
                                <span className="notification-item-title">
                                  {group.title}
                                </span>
                                <span className="notification-group-count">
                                  {group.items.length}
                                </span>
                              </div>
                              <div className="d-flex align-items-center">
                                <span className="notification-unread-dot me-2" />
                                <i
                                  className={`icon ${isExpanded
                                      ? "icon-chevron-up"
                                      : "icon-chevron-down"
                                    } notification-group-arrow`}
                                />
                              </div>
                            </div>

                            {isExpanded && (
                              <div className="notification-nested-list">
                                {group.items.map((item: any) => (
                                  <div
                                    key={item._id}
                                    className="notification-nested-item"
                                    onClick={() => handleNotificationClick(item)}
                                  >
                                    {item.message && (
                                      <div className="notification-item-msg">
                                        {item.message}
                                      </div>
                                    )}
                                    <div className="notification-item-time">
                                      {moment(item.createdAt).fromNow()}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            )}
            <li className="nav-item" onClick={handleLogout}>
              <a className="nav-link" title={LABELS.LOGOUT_TEXT} href="#">
                <i className={`icon ${icons.ICON_LOGOUT}`}></i>
              </a>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link user-profile"
                title={LABELS.PROFILE_TEXT}
                to={URLS.USER_PROFILE}
              >
                <img src={userLogo ? IMAGE_URL + userLogo : UserImage} alt="" />
                <div>
                  <span className="text-capitalize">{username}</span>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
